import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const RetrievePortfolioData = createAsyncThunk(
  "retrievePortfolio",
  async (arg, { rejectWithValue }) => {
    
    try {
      const response = await doPost(urls?.retrievePortfolio, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const RetrievePortfolioDataSlice = createSlice({
  name: "retrievePortfolio",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    retrievePortfolioReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [RetrievePortfolioData.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.error = null;
      state.data = payload;
    },
    [RetrievePortfolioData.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    [RetrievePortfolioData.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.data = false;
    },
  },
});

export const { retrievePortfolioReset } = RetrievePortfolioDataSlice.actions;
